export default __webpack_public_path__ + "static/ads-header-7c817b1b1f8e9a75b1c525f6e9c113b0.svg";